import { render, staticRenderFns } from "./ReviewOrderTable.vue?vue&type=template&id=08327754"
import script from "./ReviewOrderTable.vue?vue&type=script&lang=js"
export * from "./ReviewOrderTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports